import { GatekeeperComponent } from "./gatekeeper/gatekeeper.component";
import { GovernmentComponent } from "./government/government.component";
import { SecurityComponent } from "./security/security.component";
import { ModulesComponent } from "./modules/modules.component";
import { DocumentationComponent } from "./documentation/documentation.component";
import { PricingComponent } from "./pricing/pricing.component";
import { TechnologyComponent } from "./technology/technology.component";
import { FeaturesComponent } from "./features/features.component";
import { HomeComponent } from "./home/home.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegulationsComponent } from "./regulations/regulations.component";
import { UtilitiesComponent } from "./utilities/utilities.component";
import { SmbComponent } from "./smb/smb.component";
import { FinancialComponent } from "./financial/financial.component";
import { PartnershipComponent } from "./partnership/partnership.component";
import { ContactComponent } from "./contact/contact.component";
import { TeamComponent } from "./team/team.component";
import { ViewerComponent } from "./viewer/viewer.component";
import { ThankYouComponent } from "./thank-you/thank-you.component";
import { NotfoundComponent } from "./notfound/notfound.component";
import { AdminComponent } from "./admin/admin.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AuthGuardService } from "./auth-guard.service";
import { CustomersComponent } from "./customers/customers.component";
import { LeadsComponent } from "./leads/leads.component";
import { LeadFormComponent } from "./lead-form/lead-form.component";
import { CustomerFormComponent } from "./customer-form/customer-form.component";
import { PrivacyComponent } from "./privacy/privacy.component";
import { TosComponent } from "./tos/tos.component";
import { WhitepapersComponent } from "./whitepapers/whitepapers.component";
import { WebinarsComponent } from "./webinars/webinars.component";
import { TrainingComponent } from "./training/training.component";
import { RegopsComponent } from "./regops/regops.component";
import { RegistrationsComponent } from "./registrations/registrations.component";
import { RegistrationFormComponent } from "./registration-form/registration-form.component";
import { RegisterSelfServiceComponent } from "./register-self-service/register-self-service.component";
import { PartnerListComponent } from "./partner-list/partner-list.component";
import { PartnerFormComponent } from "./partner-form/partner-form.component";
import { EnergyUtilitiesComponent } from "./energy-utilities/energy-utilities.component";
import { ReleaseNotesComponent } from "./release-notes/release-notes.component";
import { FedrampComponent } from "./fedramp/fedramp.component";
import { OscalComponent } from "./oscal/oscal.component";
import { VitgComponent } from "./vitg/vitg.component";
import { TrainingTwoComponent } from "./training-two/training-two.component";
import { TrainingAdminComponent } from "./training-admin/training-admin.component";
import { TrainingPractitionerComponent } from "./training-practitioner/training-practitioner.component";
import { TrainingAuditorComponent } from "./training-auditor/training-auditor.component";
import { TrainingExecutiveComponent } from "./training-executive/training-executive.component";
import { ComingsoonComponent } from "./comingsoon/comingsoon.component";
import { BoardOfDirectorsComponent } from "./board-of-directors/board-of-directors.component";
import { NewsFormComponent } from "./news-form/news-form.component";
import { NewsListComponent } from "./news-list/news-list.component";
import { PressComponent } from "./press/press.component";
import { ProfilesComponent } from "./profiles/profiles.component";
import { OtherDownloadsComponent } from "./other-downloads/other-downloads.component";
import { SbomComponent } from "./sbom/sbom.component";

// Angular routes
const routes: Routes = [
	{ path: "admin", component: AdminComponent },
	{ path: "home", component: HomeComponent },
	{ path: "board-of-directors", component: BoardOfDirectorsComponent },
	{ path: "contact", component: ContactComponent },
	{
		path: "customers",
		component: CustomersComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "customer-form",
		component: CustomerFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "customer-form/:id",
		component: CustomerFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "dashboard",
		component: DashboardComponent,
		canActivate: [AuthGuardService]
	},
	{ path: "documentation", component: DocumentationComponent },
	{ path: "documentation/:module", component: DocumentationComponent },
	{ path: "features", component: FeaturesComponent },
	{ path: "fedramp", component: FedrampComponent },
	{ path: "financial", component: FinancialComponent },
	{ path: "gatekeeper/:strGate", component: GatekeeperComponent },
	{ path: "government", component: GovernmentComponent },
	{
		path: "leads",
		component: LeadsComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "lead-form/:id",
		component: LeadFormComponent,
		canActivate: [AuthGuardService]
	},
	{ path: "modules", component: ModulesComponent },
	{
		path: "news-form",
		component: NewsFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "news-form/:id",
		component: NewsFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "news",
		component: NewsListComponent,
		canActivate: [AuthGuardService]
	},
	{ path: "notfound", component: NotfoundComponent },
	{ path: "oscal", component: OscalComponent },
	{ path: "other-downloads", component: OtherDownloadsComponent },
	{
		path: "partner-form",
		component: PartnerFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "partner-form/:id",
		component: PartnerFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "partners",
		component: PartnerListComponent,
		canActivate: [AuthGuardService]
	},
	{ path: "partnership", component: PartnershipComponent },
	{ path: "press", component: PressComponent },
	{ path: "pricing", component: PricingComponent },
	{ path: "privacy", component: PrivacyComponent },
	{ path: "profiles", component: ProfilesComponent },
	{ path: "regops", component: RegopsComponent },
	{ path: "register", component: RegisterSelfServiceComponent },
	{ path: "register/client/:uuid", component: RegisterSelfServiceComponent },
	{
		path: "register/:id",
		component: RegistrationFormComponent,
		canActivate: [AuthGuardService]
	},
	{
		path: "registrations",
		component: RegistrationsComponent,
		canActivate: [AuthGuardService]
	},
	{ path: "regulations", component: RegulationsComponent },
	{ path: "release-notes", component: ReleaseNotesComponent },
	{ path: "sbom", component: SbomComponent },
	{ path: "security", component: SecurityComponent },
	{ path: "smb", component: SmbComponent },
	{ path: "team", component: TeamComponent },
	{ path: "technology", component: TechnologyComponent },
	{ path: "termsofservice", component: TosComponent },
	{ path: "training", component: TrainingComponent },
	{ path: "training/roles", component: TrainingTwoComponent },
	{ path: "trainingadmin", component: TrainingAdminComponent },
	{ path: "trainingpractitioner", component: TrainingPractitionerComponent },
	{ path: "trainingauditor", component: TrainingAuditorComponent },
	{ path: "trainingexecutive", component: TrainingExecutiveComponent },
	{ path: "comingsoon", component: ComingsoonComponent},
	{ path: "thank-you/:type", component: ThankYouComponent },
	{ path: "thank-you/:type/:license", component: ThankYouComponent },
	{ path: "utilities", component: UtilitiesComponent },
	{ path: "viewer/:page", component: ViewerComponent },
	{ path: "vitg", component: VitgComponent },
	{ path: "webinars", component: WebinarsComponent },
	{ path: "whitepapers", component: WhitepapersComponent },
	{ path: "energy-utilities", component: EnergyUtilitiesComponent },
	{ path: 'blog', loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule) },
	{ path: "", component: HomeComponent },
	{ path: "**", component: NotfoundComponent },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" }),
	],
	exports: [RouterModule],
})

export class AppRoutingModule {}
